module.exports = __webpack_public_path__ + "94d5878ccbadf78da0c32a611229fdd6.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/165.png
// module id = 1759
// module chunks = 2